import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/FirebaseAuthContext';
import { useSubscription } from '../context/SubscriptionContext';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { user, loading, logout } = useAuth();
  const { isSubscribed } = useSubscription();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <header className="sticky top-0 z-50 bg-blue-700 shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center gap-4 sm:gap-6">
        <Link to="/" className="flex items-center gap-2 text-white font-bold text-lg no-underline shrink-0">
          <img src="/logo-white.svg" alt="" width={32} height={32} className="h-8 w-8" />
          <span>DPI<span className="text-blue-200">Converter</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-5 ml-2">
          <Link to="/" className="text-sm font-medium text-blue-100 hover:text-white transition-colors">Home</Link>
          <Link to="/tools" className="text-sm font-medium text-blue-100 hover:text-white transition-colors">Free Tools</Link>
          <Link to="/pricing" className="text-sm font-medium text-blue-100 hover:text-white transition-colors">Pricing</Link>
          <Link to="/contact" className="text-sm font-medium text-blue-100 hover:text-white transition-colors">Contact</Link>
        </nav>

        <div className="ml-auto flex items-center gap-3">
          {loading ? (
            // Session is still being restored: keep the space, show nothing (avoids a "Sign in" flash)
            <span className="inline-block h-9 w-40" aria-hidden="true" />
          ) : (<>
          {user ? (
            <>
              <span className="hidden lg:inline text-sm text-blue-100 max-w-[200px] truncate" title={user.email}>
                {user.email}
              </span>
              <button
                onClick={handleLogout}
                className="text-sm font-medium text-blue-100 hover:text-white transition-colors"
              >
                Sign out
              </button>
            </>
          ) : (
            <Link to="/login" className="text-sm font-medium text-white hover:text-blue-100 transition-colors">
              Sign in
            </Link>
          )}

          {isSubscribed ? (
            <span className="bg-white/15 text-white px-3 py-1.5 rounded-lg text-sm font-bold">👑 Premium</span>
          ) : (
            <button
              onClick={() => navigate('/pricing')}
              className="bg-white hover:bg-blue-50 text-blue-700 px-4 py-2 rounded-lg text-sm font-bold shadow-sm transition-colors"
            >
              Go Premium ⚡
            </button>
          )}
          </>)}
        </div>
      </div>
    </header>
  );
};

export default Header;
